/*
    clone: the two object without functions
*/
// `object` rather than a keyed record: every caller hands in a concrete instance (a BCF viewpoint
// or a `Partial<BcfViewpointData>`) and walks it by dynamic key, and the returned `{}` is what the
// callers already declare their receiving variable as.
// `clone` is asserted per write rather than re-declared: annotating it would change this function's
// inferred return type from `{}`, which is what the callers declare their variable as.
export default function cloneObject(obj: object) {
  const clone = {};
  // `object` carries no index signature, so walking it needs a keyed view of the same value. Each
  // value comes back as `unknown` and is narrowed by the `typeof` checks below before it is used,
  // so this view claims nothing about what `obj` actually holds.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- widening `object` to a string-keyed view whose values are all `unknown`; the loop narrows every value with `typeof` before touching it
  const source = obj as Record<string, unknown>;
  for (const i in obj) {
    const value = source[i];
    // `typeof value === "object"` already excludes `undefined`, so only `null` has to be ruled out.
    if (typeof value === "object" && value !== null) {
      (clone as Record<string, unknown>)[i] = cloneObject(value);
    } else if (typeof value !== "function") {
      (clone as Record<string, unknown>)[i] = value;
    }
  }
  return clone;
}
